import React from 'react';
import PropTypes from 'prop-types';

const Atribut = ({ nama, data }) => {
  if (nama === 'Email') {
    return (
      <div className="detail-atribut justify-content-between">
        <h4 className="font-24">{ nama }</h4>
        <p className="font-20">{ data }</p>
      </div>
    );
  }

  return (
    <div className="detail-atribut justify-content-between">
      <h4 className="font-24">{ nama }</h4>
      <p className="font-20 capitalize">{ data }</p>
    </div>
  );
};

Atribut.propTypes = {
  nama: PropTypes.string,
  data: PropTypes.string,
};

Atribut.defaultProps = {
  nama: '',
  data: '',
};

export default Atribut;
